import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import { InputCheckbox } from "@creditornot/cb-checkbox";
import * as React from "react";
import { forwardRef, useId, useState } from "react";
import { clsx } from "@creditornot/cb-utils";
import { typographyClassName } from "@creditornot/cb-ingredients";
import { color } from "@creditornot/cb-ingredients/design-tokens";
import { InputRadio } from "@creditornot/cb-radio";
import "./style.css";
const SvgCaretright = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M19.5 11.972c0-.662-.283-1.292-.778-1.73L7.592.433a1.84 1.84 0 00-2.568.195 1.85 1.85 0 00.134 2.578l9.732 8.579a.25.25 0 010 .376l-9.732 8.578a1.849 1.849 0 00.609 3.17 1.84 1.84 0 001.825-.397l11.126-9.807a2.312 2.312 0 00.782-1.732z" }) }));
const menuItemBaseClass = clsx(typographyClassName.Body3, "cb_menuItemBaseClass_mt6f");
const SubLabel = /* @__PURE__ */ styled("div")({
  name: "SubLabel",
  class: "cb_MenuActionItem_SubLabel_s1fh",
  propsAsIs: false
});
const IconContainer$1 = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_MenuActionItem_IconContainer_ir6t",
  propsAsIs: false
});
const _exp2$2 = () => IconContainer$1;
const LargeIconContainer = /* @__PURE__ */ styled(_exp2$2())({
  name: "LargeIconContainer",
  class: "cb_MenuActionItem_LargeIconContainer_l1rv",
  propsAsIs: true
});
const IconBG = /* @__PURE__ */ styled("div")({
  name: "IconBG",
  class: "cb_MenuActionItem_IconBG_ilch",
  propsAsIs: false
});
const rootClass = "cb_MenuActionItem_rootClass_r16i";
const rootClasses = clsx(menuItemBaseClass, rootClass);
const _exp19 = () => ({
  $rightPadding
}) => $rightPadding;
const LeftContent = /* @__PURE__ */ styled("div")({
  name: "LeftContent",
  class: "cb_MenuActionItem_LeftContent_l10h",
  propsAsIs: false,
  vars: {
    "l10hrzny-0": [_exp19(), "px"]
  }
});
const RightContent$1 = /* @__PURE__ */ styled("div")({
  name: "RightContent",
  class: "cb_MenuActionItem_RightContent_r18u",
  propsAsIs: false
});
const ContentContainer = /* @__PURE__ */ styled("div")({
  name: "ContentContainer",
  class: "cb_MenuActionItem_ContentContainer_caqr",
  propsAsIs: false
});
const Content$4 = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_MenuActionItem_Content_cjrt",
  propsAsIs: false
});
const MenuActionItem = forwardRef(({
  children,
  className,
  focused,
  icon,
  leftContent,
  rightContent,
  role = "menuitem",
  selected = false,
  subLabel,
  tabIndex = 0,
  variant = "black",
  ...rest
}, ref) => /* @__PURE__ */ jsxs("button", {
  ...rest,
  className: clsx(className, rootClasses),
  "data-cb-menu-item": true,
  "data-highlighted": focused ? true : void 0,
  "data-managed-focus": focused !== void 0 ? true : void 0,
  "data-selected": selected ? true : void 0,
  "data-variant": variant,
  ref,
  role,
  tabIndex,
  type: "button",
  children: [!!leftContent && /* @__PURE__ */ jsx(LeftContent, {
    $rightPadding: subLabel ? 4 : 0,
    children: leftContent
  }), !leftContent && !!icon && /* @__PURE__ */ jsx(LeftContent, {
    $rightPadding: subLabel ? 4 : 0,
    children: subLabel ? /* @__PURE__ */ jsxs(LargeIconContainer, {
      children: [/* @__PURE__ */ jsx(IconBG, {}), icon]
    }) : /* @__PURE__ */ jsx(IconContainer$1, {
      children: icon
    })
  }), /* @__PURE__ */ jsxs(ContentContainer, {
    children: [/* @__PURE__ */ jsx(Content$4, {
      children
    }), !!subLabel && /* @__PURE__ */ jsx(SubLabel, {
      className: typographyClassName.Small,
      children: subLabel
    })]
  }), !!rightContent && /* @__PURE__ */ jsx(RightContent$1, {
    children: rightContent
  })]
}));
MenuActionItem.displayName = "MenuActionItem";
const Root$2 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_MenuAccordionItem_Root_rzfu",
  propsAsIs: false
});
const LeftIconContainer = /* @__PURE__ */ styled("div")({
  name: "LeftIconContainer",
  class: "cb_MenuAccordionItem_LeftIconContainer_lu1p",
  propsAsIs: false
});
const _exp$1 = () => LeftIconContainer;
const RightIconContainer = /* @__PURE__ */ styled(_exp$1())({
  name: "RightIconContainer",
  class: "cb_MenuAccordionItem_RightIconContainer_r1by",
  propsAsIs: true
});
const _exp2$1 = () => SvgCaretright;
const StyledCaretIcon = /* @__PURE__ */ styled(_exp2$1())({
  name: "StyledCaretIcon",
  class: "cb_MenuAccordionItem_StyledCaretIcon_s1oc",
  propsAsIs: true
});
const ItemContent = /* @__PURE__ */ styled("div")({
  name: "ItemContent",
  class: "cb_MenuAccordionItem_ItemContent_i1m1",
  propsAsIs: false
});
const Collapse = /* @__PURE__ */ styled("div")({
  name: "Collapse",
  class: "cb_MenuAccordionItem_Collapse_c13o",
  propsAsIs: false
});
const CollapsedContent$1 = /* @__PURE__ */ styled("div")({
  name: "CollapsedContent",
  class: "cb_MenuAccordionItem_CollapsedContent_c1r4",
  propsAsIs: false
});
const MenuAccordionItem = ({
  accordionContent,
  active = false,
  caretPosition = "left",
  children,
  className,
  disabled = false,
  focused,
  id: idProp,
  menuItemRef,
  open = false,
  tabIndex = 0,
  variant = "black",
  ...rest
}) => {
  const generatedButtonId = useId();
  const collapsedContentId = useId();
  const buttonId = idProp ?? generatedButtonId;
  const [renderCollapsedContent, setRenderCollapsedContent] = useState(open);
  React.useEffect(() => {
    if (open && !renderCollapsedContent) {
      setRenderCollapsedContent(true);
    }
  }, [open, renderCollapsedContent]);
  return /* @__PURE__ */ jsxs(Root$2, {
    "data-cb-menu-item": true,
    children: [/* @__PURE__ */ jsxs("button", {
      "aria-controls": renderCollapsedContent ? collapsedContentId : void 0,
      "aria-expanded": open,
      className: clsx(rootClasses, className),
      "data-highlighted": focused ? true : void 0,
      "data-managed-focus": focused !== void 0 ? true : void 0,
      "data-selected": active ? true : void 0,
      "data-variant": variant,
      disabled,
      id: buttonId,
      tabIndex,
      ...rest,
      ref: menuItemRef,
      type: "button",
      children: [caretPosition === "left" && /* @__PURE__ */ jsx(LeftIconContainer, {
        children: /* @__PURE__ */ jsx(StyledCaretIcon, {
          "data-direction": open ? "down" : "right"
        })
      }), /* @__PURE__ */ jsx(ItemContent, {
        children
      }), caretPosition === "right" && /* @__PURE__ */ jsx(RightIconContainer, {
        children: /* @__PURE__ */ jsx(StyledCaretIcon, {
          "data-direction": open ? "down" : "right"
        })
      })]
    }), /* @__PURE__ */ jsx(Collapse, {
      "data-hidden": !open,
      onTransitionEnd: () => {
        if (!open)
          setRenderCollapsedContent(false);
      },
      children: renderCollapsedContent ? /* @__PURE__ */ jsx(CollapsedContent$1, {
        "aria-labelledby": buttonId,
        id: collapsedContentId,
        role: "menu",
        children: accordionContent
      }) : null
    })]
  });
};
const Container = /* @__PURE__ */ styled("div")({
  name: "Container",
  class: "cb_MenuAccordionCheckboxItem_Container_c22c",
  propsAsIs: false
});
const Content$3 = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_MenuAccordionCheckboxItem_Content_c1yc",
  propsAsIs: false
});
const CollapsedContent = /* @__PURE__ */ styled("div")({
  name: "CollapsedContent",
  class: "cb_MenuAccordionCheckboxItem_CollapsedContent_cdlx",
  propsAsIs: false
});
const MenuAccordionCheckboxItem = ({
  accordionContent,
  caretPosition,
  checkboxProps = {},
  children,
  disabled,
  ...rest
}) => /* @__PURE__ */ jsx(MenuAccordionItem, {
  accordionContent: /* @__PURE__ */ jsx(CollapsedContent, {
    "data-caret-position": caretPosition,
    children: accordionContent
  }),
  caretPosition,
  disabled,
  ...rest,
  children: /* @__PURE__ */ jsxs(Container, {
    children: [/* @__PURE__ */ jsx(InputCheckbox, {
      ...checkboxProps,
      disabled: checkboxProps.disabled === void 0 ? disabled : checkboxProps.disabled,
      onClick: (event) => {
        event.stopPropagation();
        if (checkboxProps.onClick) {
          checkboxProps.onClick(event);
        }
      }
    }), /* @__PURE__ */ jsx(Content$3, {
      children
    })]
  })
});
const root$1 = "cb_MenuCheckboxItem_root_r1v0";
const CheckboxContainer = /* @__PURE__ */ styled("div")({
  name: "CheckboxContainer",
  class: "cb_MenuCheckboxItem_CheckboxContainer_c1ca",
  propsAsIs: false
});
const Content$2 = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_MenuCheckboxItem_Content_c1bj",
  propsAsIs: false
});
const MenuCheckboxItem = ({
  checked,
  children,
  className,
  disabled,
  focused,
  onBlur,
  onChange,
  onClick,
  onFocus,
  partiallyChecked,
  role = "menuitemcheckbox",
  selected,
  tabIndex,
  value,
  ...rest
}, ref) => /* @__PURE__ */ jsxs("label", {
  className: clsx(root$1, menuItemBaseClass, className),
  "data-disabled": disabled ? true : void 0,
  "data-highlighted": focused ? true : void 0,
  "data-managed-focus": focused !== void 0 ? true : void 0,
  "data-selected": selected ? true : void 0,
  ...rest,
  "data-cb-menu-item": true,
  ref,
  children: [/* @__PURE__ */ jsx(CheckboxContainer, {
    children: /* @__PURE__ */ jsx(InputCheckbox, {
      checked,
      disableFocusAndActiveStyles: true,
      disabled,
      onBlur,
      onChange,
      onClick,
      onFocus,
      partiallyChecked,
      readOnly: !onChange,
      role,
      tabIndex,
      value
    })
  }), /* @__PURE__ */ jsx(Content$2, {
    children
  })]
});
const MenuCheckboxItem$1 = forwardRef(MenuCheckboxItem);
const Root$1 = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_MenuItemGroup_Root_ruo8",
  propsAsIs: false
});
const Header = /* @__PURE__ */ styled("div")({
  name: "Header",
  class: "cb_MenuItemGroup_Header_h1qx",
  propsAsIs: false
});
const Items = /* @__PURE__ */ styled("div")({
  name: "Items",
  class: "cb_MenuItemGroup_Items_ig7x",
  propsAsIs: false
});
const MenuItemGroup = forwardRef(({
  children,
  role = "group",
  title,
  ...rest
}, ref) => {
  const headerId = useId();
  return /* @__PURE__ */ jsxs(Root$1, {
    ...rest,
    "aria-labelledby": title ? headerId : void 0,
    "data-cb-menu-item": true,
    ref,
    role,
    children: [!!title && /* @__PURE__ */ jsx(Header, {
      className: typographyClassName.Small,
      id: headerId,
      children: title
    }), /* @__PURE__ */ jsx(Items, {
      children
    })]
  });
});
MenuItemGroup.displayName = "MenuItemGroup";
const Root = /* @__PURE__ */ styled("a")({
  name: "Root",
  class: "cb_MenuLinkItem_Root_r8a2",
  propsAsIs: false
});
const _exp = () => IconContainer$1;
const IconContainer = /* @__PURE__ */ styled(_exp())({
  name: "IconContainer",
  class: "cb_MenuLinkItem_IconContainer_ibvg",
  propsAsIs: true
});
const _exp2 = () => ({
  $fontWeight
}) => $fontWeight === "bold" ? 700 : 400;
const Content$1 = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_MenuLinkItem_Content_c3za",
  propsAsIs: false,
  vars: {
    "c3zaxu8-0": [_exp2()]
  }
});
const _exp3 = () => ({
  $selected
}) => $selected ? color.textOnBgFillBrand : color.textSubdued;
const RightContent = /* @__PURE__ */ styled("div")({
  name: "RightContent",
  class: "cb_MenuLinkItem_RightContent_r100",
  propsAsIs: false,
  vars: {
    "r100v67i-0": [_exp3()]
  }
});
const MenuLinkItem = forwardRef(({
  active = false,
  children,
  className,
  disabled = false,
  focused,
  icon,
  rightContent,
  role = "menuitem",
  tabIndex = 0,
  variant = "black",
  ...rest
}, ref) => /* @__PURE__ */ jsxs(Root, {
  className: clsx(rootClasses, className),
  "data-highlighted": focused ? true : void 0,
  "data-managed-focus": focused !== void 0 ? true : void 0,
  "data-selected": active ? true : void 0,
  "data-variant": variant,
  disabled,
  ref,
  role,
  tabIndex,
  ...rest,
  "data-cb-menu-item": true,
  children: [!!icon && /* @__PURE__ */ jsx(IconContainer, {
    children: icon
  }), /* @__PURE__ */ jsx(Content$1, {
    $fontWeight: active ? "bold" : "normal",
    children
  }), !!rightContent && /* @__PURE__ */ jsx(RightContent, {
    $selected: active,
    children: rightContent
  })]
}));
MenuLinkItem.displayName = "MenuLinkItem";
const root = "cb_MenuRadioItem_root_r1a1";
const RadioContainer = /* @__PURE__ */ styled("div")({
  name: "RadioContainer",
  class: "cb_MenuRadioItem_RadioContainer_r39g",
  propsAsIs: false
});
const Content = /* @__PURE__ */ styled("div")({
  name: "Content",
  class: "cb_MenuRadioItem_Content_c1vd",
  propsAsIs: false
});
const MenuRadioItem = ({
  checked,
  children,
  className,
  disabled,
  focused,
  onBlur,
  onChange,
  onClick,
  onFocus,
  role = "menuitemradio",
  selected,
  tabIndex,
  value,
  ...rest
}, ref) => /* @__PURE__ */ jsxs("label", {
  className: clsx(root, menuItemBaseClass, className),
  "data-disabled": disabled ? true : void 0,
  "data-highlighted": focused ? true : void 0,
  "data-managed-focus": focused !== void 0 ? true : void 0,
  "data-selected": selected ? true : void 0,
  ...rest,
  "data-cb-menu-item": true,
  ref,
  children: [/* @__PURE__ */ jsx(RadioContainer, {
    children: /* @__PURE__ */ jsx(InputRadio, {
      checked,
      disableFocusAndActiveStyles: true,
      disabled,
      onBlur,
      onChange,
      onClick,
      onFocus,
      readOnly: !onChange,
      role,
      tabIndex,
      value
    })
  }), /* @__PURE__ */ jsx(Content, {
    children
  })]
});
const MenuRadioItem$1 = forwardRef(MenuRadioItem);
export {
  MenuAccordionCheckboxItem,
  MenuAccordionItem,
  MenuActionItem,
  MenuCheckboxItem$1 as MenuCheckboxItem,
  MenuItemGroup,
  MenuLinkItem,
  MenuRadioItem$1 as MenuRadioItem
};
//# sourceMappingURL=index.js.map
